/**
 * 节点画布项目：列表 / 保存 / 读取 / 删除（表 node_canvas_projects）
 */

import api from '@/utils/api'

function unwrapList(res) {
  if (res == null) return []
  if (typeof res === 'string') {
    try {
      return unwrapList(JSON.parse(res))
    } catch {
      return []
    }
  }
  if (!res || typeof res !== 'object') return []
  if (Array.isArray(res)) return res
  if (Array.isArray(res.list)) return res.list
  // 少数网关/框架会把列表直接放在 data 数组里
  if (Array.isArray(res.data)) {
    const rd = res.data
    if (
      rd.length > 0 &&
      typeof rd[0] === 'object' &&
      rd[0] !== null &&
      ('uuid' in rd[0] || 'title' in rd[0] || 'user_id' in rd[0])
    ) {
      return rd
    }
  }
  const d = res.data
  if (d && typeof d === 'object' && !Array.isArray(d)) {
    if (Array.isArray(d.list)) return d.list
    if (Array.isArray(d.data)) return d.data
    if (d.data && typeof d.data === 'object' && Array.isArray(d.data.list)) return d.data.list
  }
  return []
}

function extractListMetaError(res) {
  if (!res || typeof res !== 'object') return ''
  const d = res.data
  if (d && typeof d === 'object' && !Array.isArray(d)) {
    const err = d.list_error || d.listError
    if (err) return String(err)
  }
  return ''
}

function assertApiOk(res) {
  if (res == null || typeof res !== 'object') return
  const c = res.code
  if (c === undefined || c === null) return
  const n = Number(c)
  if (n === 0 || n === 200) return
  throw new Error(res.message || res.msg || res.error || `接口 code=${c}`)
}

export async function fetchNodeCanvasList(opts) {
  const limit = opts && opts.limit != null ? opts.limit : 30
  const res = await api.get('/node_canvas_projects', { params: { limit } })
  assertApiOk(res)
  const rows = unwrapList(res)
  return {
    rows: Array.isArray(rows) ? rows : [],
    listError: extractListMetaError(res)
  }
}

export async function fetchNodeCanvasDetail(uuid) {
  const id = String(uuid || '').trim()
  if (!id) throw new Error('缺少 uuid')
  const res = await api.get(`/node_canvas_projects/${encodeURIComponent(id)}`)
  assertApiOk(res)
  let data = res && res.data != null ? res.data : res
  if (data && typeof data === 'object' && data.data && data.data.uuid != null) {
    data = data.data
  }
  if (!data || data.uuid == null) {
    throw new Error('项目不存在或无权访问')
  }
  return {
    uuid: data.uuid,
    title: data.title || '',
    thumb_url: data.thumb_url || '',
    state: data.state && typeof data.state === 'object' ? data.state : {}
  }
}

export async function saveNodeCanvas(payload) {
  const uuid = String(payload.uuid || '').trim()
  if (!uuid) throw new Error('缺少 uuid')
  const res = await api.post('/node_canvas_projects', {
    uuid,
    title: payload.title || '未命名画布',
    thumb_url: payload.thumb_url || '',
    state: payload.state
  })
  assertApiOk(res)
}

export async function deleteNodeCanvas(uuid) {
  const id = String(uuid || '').trim()
  if (!id) throw new Error('缺少 uuid')
  const res = await api.delete(`/node_canvas_projects/${encodeURIComponent(id)}`)
  assertApiOk(res)
}
